import script from "./OppositeWorkList.vue?vue&type=script&setup=true&lang=js"
export * from "./OppositeWorkList.vue?vue&type=script&setup=true&lang=js"

import "./OppositeWorkList.vue?vue&type=style&index=0&id=2680c073&lang=sass"

const __exports__ = script;

export default __exports__